var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',[_c('oil-cap',{attrs:{"title":'нефтебазы'.toUpperCase(),"buttons":[
                {
                  route: 'terminal',
                  name: 'добавить базу'
                }
      ]}}),_c('v-divider',{staticClass:"my-2"}),_c('oil-table',{attrs:{"items":_vm.terminals,"paginate":_vm.count,"keys":[
        {text:'название' ,value:'Name'},
        {text:'адрес',value:'Address'},
        {text:'ответственное лицо',value:'ResponsiblePerson'},
        {text:'договор',value:'ContractNumber'},
        {text:'статус',value:'Status'},
        {text:'',value:'UPDATE_ID'},
        {text:'',value:'DELETE_ID'} ]},on:{"paginateAction":_vm.terminalPaginate},scopedSlots:_vm._u([{key:"UPDATE_ID",fn:function(ref){
    var value = ref.value;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
    var on = ref.on;
    var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){return _vm.rowClick(value)}}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(" mdi-pen ")])],1)]}}],null,true)},[_c('span',[_vm._v("РЕДАКТИ́РОВАТЬ")])])]}},{key:"DELETE_ID",fn:function(ref){
    var value = ref.value;
return [_c('v-row',[_c('v-col',{attrs:{"md":"6","offset-md":"3"}},[_c('oil-modal',{attrs:{"value":value,"tooltipMessage":"УДАЛИТЬ","mdiIcon":"mdi-delete","accept":_vm.deleteTerminal}})],1)],1)]}}],null,false,1728697543)})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }